<template>
	<v-dialog v-model="alert.show" persistent width="600">
		<v-card class="pa-4">
			<v-card-title>{{ alert.title }}</v-card-title>

			<v-card-subtitle>{{ alert.subtitle }}</v-card-subtitle>

			<v-card-text class="pb-0">
				<v-row>
					<v-col cols="12" v-if="alert.message != null">
						{{ alert.message }}
					</v-col>
					<v-col cols="12" class="d-flex flex-column">
						<span
							v-for="(error, key) in alert.errors"
							:key="4854 + key"
						>
							{{ error }}
						</span>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="d-flex justify-end">
				<template
					v-if="
						alert.redirect === null || alert.redirect === undefined
					"
				>
					<v-btn color="primary" @click="alert.show = false">
						Ok
					</v-btn>
				</template>

				<template v-else>
					<router-link :to="{ name: alert.redirect }">
						<v-btn color="primary">Ok</v-btn>
					</router-link>
				</template>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { EventBus } from "@/main";
export default {
	name: "Alert",
	data() {
		return {
			alert: { title: null, message: null, show: false, redirect: null },
		};
	},
	created() {
		EventBus.$on("Error", (data) => {
			var message = null;
			var errors = [];
			var title = "Error";
			var subtitle = null;

			data.alertShow = data.alertShow ? true : false;

			data.errorsShow = data.errorsShow ? true : false;

			if (data.error.response) {
				var response_data = data.error.response.data;

				if (response_data.errors) {
					EventBus.$emit("InputError", response_data.errors);

					if (data.errorsShow) {
						title = response_data.message;
						subtitle = data.error;
						errors = this.errorsArrayEncode(response_data.errors);
					}
				} else {
					message = response_data.message;
					subtitle = response_data.statusText;
					title = data.error;
				}
			} else {
				title = data.error;
				subtitle = data.subtitle === undefined ? null : data.subtitle;
				message = data.message === undefined ? null : data.message;
			}

			if (data.alertShow || data.errorsShow) {
				this.alert = {
					title: title,
					subtitle: subtitle,
					message: message,
					errors: errors,
					show: true,
				};
			}
		});
	},
	methods: {
		errorsArrayEncode(errors) {
			var array = [];
			for (var campo in errors) {
				errors[campo].forEach((error, key) => {
					// array.push(`${campo}: ${errors[campo][key]}`);
					array.push(`${errors[campo][key]}`);
				});
			}
			return array;
		},
	},
};
</script>

<style lang="css" scoped></style>
